var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReason4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "1116.082 2272.045 84.564 93.842",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Urban_Renewal_Tool_-_Homepage_1366px_"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 4535
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Urban_Renewal_Tool_-_Homepage_1366px_",
    "data-name": "Urban Renewal Tool - Homepage 1366px ",
    className: "cls-3",
    style: {
      clipPath: "url(#clip-Urban_Renewal_Tool_-_Homepage_1366px_)"
    },
    transform: "matrix(1, 0, 0, 1, 67.621826, -1705.269897)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hp_impact_renewal_icon4",
    "data-name": "hp_impact renewal_icon4",
    transform: "matrix(1, 0, 0, 1, 1056.810547, 3987.611084)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1614",
    "data-name": "Group 1614"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2460",
    "data-name": "Path 2460",
    className: "cls-1022",
    d: "M6487.718,7265.919h12.7l-3.178,6.354,3.178,6.354H6487.7v-3.177",
    transform: "translate(-6432.413 -7262.742)",
    style: {
      fill: "rgb(215, 220, 228)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2461",
    "data-name": "Path 2461",
    className: "cls-1022",
    d: "M6471.434,7262.3h14.3v12.709h-14.3",
    transform: "translate(-6430.751 -7262.304)",
    style: {
      fill: "rgb(215, 220, 228)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1613",
    "data-name": "Group 1613",
    transform: "translate(0 1.577)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2462",
    "data-name": "Path 2462",
    className: "cls-1014",
    d: "M6437.537,7310.06l-8.366-5.976a3.6,3.6,0,0,1-.96-4.837l2.46-3.936a12.555,12.555,0,0,1,10.65-5.9h24.812s.364,5.394-4.765,6.354c-3.1.58-11.121,1.588-11.121,1.588v7.94l7.943,11.116v11.128",
    transform: "translate(-6426.417 -7266.253)",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2463",
    "data-name": "Path 2463",
    className: "cls-1014",
    d: "M6446.131,7338.766l1.588-22.241,6.355,6.354v7.943",
    transform: "translate(-6428.264 -7269.019)",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2464",
    "data-name": "Path 2464",
    className: "cls-1014",
    d: "M6426.245,7345.5l8.117-3.177h6.966l2.773-1.589h4.87l3.247-7.943h6.493l4.87,3.177h6.493l3.247,3.177h6.493l6.493,6.354",
    transform: "translate(-6426.245 -7270.991)",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2465",
    "data-name": "Path 2465",
    className: "cls-1014",
    d: "M6435.284,7301.844l3.177-1.59v38.128",
    transform: "translate(-6427.34 -7267.046)",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_317",
    "data-name": "Line 317",
    className: "cls-1014",
    y2: 36.538,
    transform: "translate(38.878 28.442)",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_318",
    "data-name": "Line 318",
    className: "cls-1014",
    y2: 22.241,
    transform: "translate(38.878)",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2466",
    "data-name": "Path 2466",
    className: "cls-1035",
    d: "M6446.233,7282.491a5.653,5.653,0,0,0,5.812-5.979v-2.989a5.815,5.815,0,1,0-11.625,0v2.989A5.653,5.653,0,0,0,6446.233,7282.491Z",
    transform: "translate(-6427.665 -7264.516)",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2467",
    "data-name": "Path 2467",
    className: "cls-1014",
    d: "M6489.08,7269.521h9.532l-3.177,6.354,3.177,6.354H6485.9v-3.177",
    transform: "translate(-6432.195 -7264.756)",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2468",
    "data-name": "Path 2468",
    className: "cls-1014",
    d: "M6469.632,7265.906h14.3v12.709h-14.3",
    transform: "translate(-6430.543 -7264.317)",
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReason4);
export default __webpack_public_path__ + "static/media/reason4.7e13ba4b8bd6e97728e448b2760b4358.svg";
export { ForwardRef as ReactComponent };